import { createAction } from 'Lib/reduxUtils';

import { CLEAR_INTENT, HANDLE_INTENT } from './constants';

export const handleIntent = createAction(
  HANDLE_INTENT,
  (intent: string, extraPayload?: Record<string, any>) => ({
    intent,
    extraPayload,
  })
);

export const clearIntent = createAction(CLEAR_INTENT);
